import Phaser from 'phaser';

const BG_OUTER = 0x0a0f1f;
const BG_INNER = 0x431407;
const FLAME_OUTER = 0xf97316;
const FLAME_MID = 0xfbbf24;
const FLAME_CORE = 0xfef3c7;
const STROKE = 0xffffff;

export function drawFlame(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  drawFlameShape(g, r * 1.0, FLAME_OUTER, 0xea580c);
  drawFlameShape(g, r * 0.72, FLAME_MID, 0xea580c);
  drawFlameShape(g, r * 0.42, FLAME_CORE, 0xfbbf24);
}

function drawFlameShape(
  g: Phaser.GameObjects.Graphics,
  scale: number,
  fill: number,
  stroke: number,
) {
  const pts: { x: number; y: number }[] = [
    { x: 0, y: -scale * 0.95 },
    { x: scale * 0.28, y: -scale * 0.55 },
    { x: scale * 0.18, y: -scale * 0.15 },
    { x: scale * 0.5, y: -scale * 0.05 },
    { x: scale * 0.55, y: scale * 0.35 },
    { x: scale * 0.3, y: scale * 0.75 },
    { x: 0, y: scale * 0.88 },
    { x: -scale * 0.3, y: scale * 0.75 },
    { x: -scale * 0.55, y: scale * 0.35 },
    { x: -scale * 0.5, y: -scale * 0.05 },
    { x: -scale * 0.18, y: -scale * 0.15 },
    { x: -scale * 0.28, y: -scale * 0.55 },
  ];
  g.fillStyle(fill, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.fillPath();

  g.lineStyle(2, stroke, 0.6);
  g.strokePath();
}
